import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {NgxPaginationModule} from 'ngx-pagination';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { NgxSelectModule } from 'ngx-select-ex';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CurrencyMaskModule } from 'ng2-currency-mask';

import { AuthService } from '../seguranca/auth.service';
import { VMessageModule } from '../shared/components/vmessage/vmessage.module';
import { LoginFormComponent } from './login-form/login-form.component';
import { FooterComponent } from '../shared/components/footer/footer.component';
import { FooterModule } from '../shared/components/footer/footer.module';
import { AtendimentoComponent } from './atendimento/atendimento.component';
import { CardModule } from '../shared/components/card/card.module';
import { AtendimentoService } from './atendimento/atendimento.service';
import { CadastroAtendimentoComponent } from './atendimento/cadastro/cadastro-atendimento.component';
import { CpfPipeModule } from '../shared/pipe/format-cpf/cpf-pipe.module';
import { DetalheAtendimentoComponent } from './atendimento/detalhe/detalhe-atendimento.component';
import { NovaSenhaComponent } from './nova-senha/nova-senha.component';
import { ExportarGuiaPdfComponent } from './atendimento/exportar-pdf/exportar-guia-pdf.component';

@NgModule({
    declarations: [
      LoginFormComponent,
      NovaSenhaComponent,
      AtendimentoComponent,
      CadastroAtendimentoComponent,
      DetalheAtendimentoComponent,
      ExportarGuiaPdfComponent
    ],
    exports: [
      FooterComponent
    ],
    imports: [
        BrowserAnimationsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PopoverModule,

        CpfPipeModule,
        ReactiveFormsModule,
        BsDatepickerModule,
        NgxPaginationModule,
        NgxSelectModule,
        NgxMaskDirective,
        NgxMaskPipe,
        CurrencyMaskModule,
        FooterModule,
        VMessageModule,
        CardModule,

        RouterModule
    ],
    providers: [
        AuthService,
        AtendimentoService
    ]
})
export class CoreModule { }
